import React from 'react';
// import AppImage from '../AppImage';
// import AppImage from '../AppImage';

import styles from './styles.module.scss';

export const FormHead = ({
  children,
  className = '',
  description = '',
  title = '',
  imageSrc = '/imgs/login/clipshoLogo.svg',
  content,
  headText = content?.name,
}) => {
  return (
    <div className={`${className}`}>
      <div className={`${styles.infoContainer} `}>
        {/* <AppImage src={imageSrc} alt="clipshoLogo" width={100} height={100} /> */}
        {headText && (
          <span className={`${styles.logoText} mainTextColor`}>{headText}</span>
        )}
        {description && (
          <p className={`desktop-view ${styles.text}`}>{description}</p>
        )}
        <p className={`mobile-view ${styles.textMobile}`}>{title}</p>

        {children}
      </div>
    </div>
  );
};
export const FormSubHead = ({ serverError, title, description }) => {
  return (
    <>
      {serverError !== '' && (
        <div className={styles.serverError}>
          {/* <AppImage
            src="/imgs/login/warning.svg"
            alt="warning"
            width={20}
            height={20}
            containerclassName="flex flex-row justify-center items-center"
          /> */}
          <span>{serverError}</span>
        </div>
      )}
      {title && <p className={styles.title}>{title}</p>}
      {description && <p className={styles.text}> {description}</p>}
    </>
  );
};

// export default { FormHead, FormSubHead };
